import React from 'react';
import { connect } from 'react-redux';
import { noPermissionText } from './components/shared/SharedInternationalizations';

export function UnconnectedAccessControl(props) {
  const {
    access_level,
    feature,
    permissionMessage = false,
    currentUserId,
    userToEdit,
    children,
    ifNotAllowed,
    currentUserPreferences,
  } = props;
  // function display() {
  //   if (feature) {
  //     if (feature.permissions.includes(access_level)) {
  //       return ifAllowed;
  //     } else if (
  //       userToEdit &&
  //       currentUserId === userToEdit &&
  //       feature.currentUser.includes(access_level)
  //     ) {
  //       return ifAllowed;
  //     } else {
  //       return ifNotAllowed;
  //     }
  //   } else {
  //     return '';
  //   }
  // }

  function display() {
     if (feature) {
      // Check if feature requires a preference (but skip for User Admins - level 10)
      if (feature.requiresPreference && access_level !== 10) {
        const hasPreference = currentUserPreferences?.[feature.requiresPreference] === true;
        
        // If feature requires preference and user has it, grant access based on currentUser array
        if (hasPreference && feature.currentUser.includes(access_level)) {
          return children;
        }
        
        // Must have the preference enabled to proceed
        if (!hasPreference) {
          if (permissionMessage) {
            return ifNotAllowed || <div><h1 data-test="no-permission">{noPermissionText}</h1></div>;
          } else {
            return '';
          }
        }
      }

      // Original access level checks
      if (feature.permissions.includes(access_level)) {
        return children;
      } else if (
        userToEdit &&
        currentUserId === userToEdit &&
        feature.currentUser.includes(access_level)
      ) {
        return children;
      } else {
        if (permissionMessage) {
          if (ifNotAllowed) {
            return ifNotAllowed;
          } else {
            return (
              <div>
                <h1 data-test="no-permission">{noPermissionText}</h1>
              </div>
            );
          }
        } else {
          return '';
        }
      }
    }
  }

  return display();
}

const mapStateToProps = (state) => {
  return {
    access_level: state.currentUser.preferences.access_level,
    currentUserId: state.currentUser.id,
    currentUserPreferences: state.currentUser.preferences,
  };
};

export default connect(mapStateToProps)(UnconnectedAccessControl);
